import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import { Box } from 'foundations-components/transitional/components/Box';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { getProductIndexHrefWithBundleAssociations } from 'products-ui-components/utils/links';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductId } from '../../contexts/ProductIdContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_DISPLAYED_BUNDLES = 3;
const BundleList = ({
  bundles
}) => /*#__PURE__*/_jsx(List, {
  paddingInlineStart: "600",
  "data-test-id": "associated-bundles-list",
  styled: true,
  children: bundles.slice(0, MAX_DISPLAYED_BUNDLES).map(bundle => /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(ExpandableText, {
      children: getProperty(bundle, 'name')
    })
  }, bundle.objectId))
});
const ViewAllBundlesLink = ({
  productId
}) => /*#__PURE__*/_jsx(Box, {
  marginBlockStart: "400",
  children: /*#__PURE__*/_jsx(Link, {
    href: getProductIndexHrefWithBundleAssociations(productId),
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.deactivate.viewAll"
    })
  })
});
const ModalDescription = ({
  associatedBundles,
  productId
}) => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    textAlign: "left",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.deactivate.messageWithBundles"
    }), /*#__PURE__*/_jsx(BundleList, {
      bundles: associatedBundles
    }), /*#__PURE__*/_jsx(ViewAllBundlesLink, {
      productId: productId
    }), /*#__PURE__*/_jsx(Box, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "modal.deactivate.bundleRemovalWarning"
      })
    })]
  });
};
const DeactivateProductModalComponent = ({
  onConfirm,
  onReject
}) => {
  const {
    associatedBundles
  } = useProductData();
  const productId = useProductId();
  if (!(associatedBundles !== null && associatedBundles !== void 0 && associatedBundles.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.deactivate.buttons.confirm"
    }),
    confirmUse: "primary",
    "data-test-id": "deactivate-product-modal",
    description: /*#__PURE__*/_jsx(ModalDescription, {
      associatedBundles: associatedBundles,
      productId: productId
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.deactivate.header"
    }),
    onConfirm: onConfirm,
    onReject: onReject,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.deactivate.buttons.reject"
    }),
    rejectUse: "secondary",
    use: "info",
    width: 592
  });
};
export const DeactivateProductModal = /*#__PURE__*/memo(DeactivateProductModalComponent);